module.exports = __webpack_public_path__ + "static/media/offer.dc170854.png";